/* Sample Kit Offer — starter pack buy box.

   Selecting a scent updates the gallery, the headline totals and the recurring
   line without a round trip; the CTA adds the sample kit and the chosen scent
   (as a SKIO subscription) in one request, then applies the offer's discount
   code. */
(function () {
  'use strict';

  if (window.__skoOfferInit) return;
  window.__skoOfferInit = true;

  function money(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, format); } catch (e) { /* fall through */ }
    }
    return '$' + (cents / 100).toFixed(2);
  }

  var tipDismissBound = false;

  function closeOpenTips() {
    document.querySelectorAll('[data-sko-tip-btn][aria-expanded="true"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  /* The tooltip opens on hover in CSS. Touch has no hover, so the icon also
     toggles aria-expanded, which the CSS keys off as a second trigger. */
  function wireTooltips(root) {
    var tips = root.querySelectorAll('[data-sko-tip]');
    if (!tips.length) return;

    function closeAll(except) {
      tips.forEach(function (tip) {
        if (tip === except) return;
        var b = tip.querySelector('[data-sko-tip-btn]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    tips.forEach(function (tip) {
      var btn = tip.querySelector('[data-sko-tip-btn]');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = btn.getAttribute('aria-expanded') === 'true';
        closeAll(tip);
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });

      // A tap inside the panel should not fall through to the close handler.
      var panel = tip.querySelector('[data-sko-tip-panel]');
      if (panel) panel.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    // Outside-click and Escape are bound once for the document, not per
    // section, so a theme-editor section reload cannot stack them up.
    if (!tipDismissBound) {
      tipDismissBound = true;
      document.addEventListener('click', closeOpenTips);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeOpenTips();
      });
    }
  }

  function wireVideos(root) {
    var rail = root.querySelector('[data-sko-videos]');
    if (!rail) return;
    var viewport = rail.querySelector('[data-sko-videos-viewport]');
    var track = rail.querySelector('[data-sko-videos-track]');
    var unmuteOnPlay = rail.getAttribute('data-unmute') !== 'false';

    // Touch scrolls the rail natively (overflow-x + touch-action in the CSS).
    // A mouse cannot drag a native scroller, so pointer-drag is implemented
    // here for mouse only — the two would fight each other on touch.
    if (viewport) {
      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

      var dragging = false, startX = 0, startLeft = 0, moved = 0;

      viewport.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true;
        moved = 0;
        startX = e.clientX;
        startLeft = viewport.scrollLeft;
        viewport.style.cursor = 'grabbing';
      });

      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        moved = e.clientX - startX;
        viewport.scrollLeft = startLeft - moved;
        if (Math.abs(moved) > 3) e.preventDefault();
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        viewport.style.cursor = '';
      }
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);

      // Swallow the click that ends a drag so it never starts a video.
      viewport.addEventListener('click', function (e) {
        if (Math.abs(moved) > 8) { e.stopPropagation(); e.preventDefault(); }
      }, true);
    }

    function cards() {
      return Array.prototype.slice.call(rail.querySelectorAll('[data-sko-video]'));
    }
    function setMuted(video, sound, muted) {
      video.muted = muted;
      if (!sound) return;
      sound.classList.toggle('is-muted', muted);
      sound.setAttribute('aria-pressed', muted ? 'false' : 'true');
    }
    function stopAll(except) {
      cards().forEach(function (card) {
        if (card === except) return;
        var v = card.querySelector('video');
        if (v) {
          v.pause();
          v.currentTime = 0;
          setMuted(v, card.querySelector('[data-sko-video-sound]'), true);
        }
        card.classList.remove('is-playing');
      });
    }

    var downX = null, downY = null;
    rail.addEventListener('pointerdown', function (e) {
      if (!e.target.closest('[data-sko-video]')) return;
      downX = e.clientX; downY = e.clientY;
    });

    rail.addEventListener('click', function (e) {
      var card = e.target.closest('[data-sko-video]');
      if (!card) return;
      var video = card.querySelector('video');
      if (!video) return;
      var sound = card.querySelector('[data-sko-video-sound]');

      if (e.target.closest('[data-sko-video-sound]')) {
        e.stopPropagation();
        setMuted(video, sound, !video.muted);
        return;
      }
      if (downX !== null) {
        var dx = e.clientX - downX, dy = e.clientY - downY;
        if (Math.sqrt(dx * dx + dy * dy) > 8) return;   // that was a scroll
      }
      if (video.paused) {
        stopAll(card);
        card.classList.add('is-playing');
        if (unmuteOnPlay) setMuted(video, sound, false);
        // A video that has not fetched anything yet needs an explicit load
        // before play(), otherwise the first click can appear to do nothing.
        if (video.readyState === 0) {
          try { video.load(); } catch (err) { /* ignore */ }
        }
        card.classList.add('is-loading');
        var clearLoading = function () { card.classList.remove('is-loading'); };
        video.addEventListener('playing', clearLoading, { once: true });
        video.addEventListener('loadeddata', clearLoading, { once: true });
        var p = video.play();
        if (p && p.catch) {
          p.catch(function () {
            setMuted(video, sound, true);
            var retry = video.play();
            if (retry && retry.catch) {
              retry.catch(function () {
                card.classList.remove('is-playing');
                card.classList.remove('is-loading');
              });
            }
          });
        }
      } else {
        video.pause();
        card.classList.remove('is-playing');
      }
    });

    rail.addEventListener('ended', function (e) {
      var card = e.target.closest && e.target.closest('[data-sko-video]');
      if (!card) return;
      card.classList.remove('is-playing');
      e.target.currentTime = 0;
    }, true);
  }

  function setup(root) {
    if (root.hasAttribute('data-sko-bound')) return;
    root.setAttribute('data-sko-bound', '');

    var scents = [];
    var dataEl = root.querySelector('[data-sko-scents]');
    try { scents = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { scents = []; }

    var kitVariant = root.getAttribute('data-kit-variant');
    var kitPrice = parseInt(root.getAttribute('data-kit-price'), 10) || 0;
    var kitCompare = parseInt(root.getAttribute('data-kit-compare'), 10) || kitPrice;
    var discount = root.getAttribute('data-discount') || '';
    var afterAdd = root.getAttribute('data-after-add') || 'checkout';
    var recurringTpl = root.getAttribute('data-recurring-template') || '';
    var clearCart = root.getAttribute('data-clear-cart') !== 'false';
    var fmt = root.getAttribute('data-money-format') || '';

    var trigger = root.querySelector('[data-sko-trigger]');
    var list = root.querySelector('[data-sko-list]');
    var mainImage = root.querySelector('[data-sko-main-image]');
    var wasEl = root.querySelector('[data-sko-total-was]');
    var nowEl = root.querySelector('[data-sko-total-now]');
    var recurringEl = root.querySelector('[data-sko-recurring]');
    var errorEl = root.querySelector('[data-sko-error]');
    var cta = root.querySelector('[data-sko-cta]');
    var ctaLabel = root.querySelector('[data-sko-cta-label]');

    var selected = null;
    // The gallery keeps the uploaded first image until a scent is actually
    // chosen; the initial render must not swap it.
    var userPicked = false;

    function render() {
      if (!selected) return;

      var t = {
        thumb: root.querySelector('[data-sko-sel-thumb]'),
        badge: root.querySelector('[data-sko-sel-badge]'),
        name: root.querySelector('[data-sko-sel-name]'),
        inspired: root.querySelector('[data-sko-sel-inspired]')
      };
      if (t.thumb) { t.thumb.src = selected.thumb || ''; t.thumb.hidden = !selected.thumb; }
      if (t.badge) {
        var hasBadge = !!(selected.badge && selected.badge.trim());
        t.badge.textContent = hasBadge ? selected.badge : '';
        t.badge.hidden = !hasBadge;
        t.badge.className = 'sko-badge'
          + (selected.badgeStyle === 'fast' ? ' sko-badge--fast' : '')
          + (selected.badgeStyle === 'sold' ? ' sko-badge--sold' : '');
      }
      if (t.name) {
        t.name.innerHTML = selected.name + ' - '
          + '<span class="sko-was">' + selected.wasFormatted + '</span> '
          + '<span class="sko-now">' + selected.nowFormatted + '</span>';
      }
      if (t.inspired) t.inspired.textContent = selected.inspired || '';

      // Totals: the kit plus the discounted scent, struck through against the
      // kit's compare-at plus the scent at full price.
      if (wasEl) wasEl.textContent = money(kitCompare + selected.priceCents, fmt);
      if (nowEl) nowEl.textContent = money(kitPrice + selected.nowCents, fmt);

      if (recurringEl) {
        recurringEl.textContent = selected.recurringFormatted
          ? recurringTpl.replace('[price]', selected.recurringFormatted)
          : '';
      }

      var primary = root.querySelector('[data-sko-primary-thumb]');
      if (!userPicked) return;
      if (selected.mainImage && mainImage) {
        mainImage.src = selected.mainImage;
        // The first slide is the placeholder showing an empty gift slot, so its
        // thumbnail has to follow the selection as well.
        if (primary) {
          var pimg = primary.querySelector('img');
          if (pimg) pimg.src = selected.thumbFull || selected.mainImage;
          primary.setAttribute('data-full', selected.mainImage);
        }
      } else if (primary) {
        var back = primary.querySelector('img');
        if (back && primary.getAttribute('data-default')) back.src = primary.getAttribute('data-default');
        if (primary.getAttribute('data-default-full')) primary.setAttribute('data-full', primary.getAttribute('data-default-full'));
      }
      if (primary) {
        root.querySelectorAll('[data-sko-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        primary.classList.add('is-active');
      }

      if (cta) {
        cta.disabled = !!selected.soldOut;
        cta.setAttribute('aria-disabled', selected.soldOut ? 'true' : 'false');
      }
    }

    function select(id) {
      var match = scents.filter(function (s) { return s.id === id; })[0];
      if (!match || match.soldOut) return;
      selected = match;
      userPicked = true;
      render();
      close();
    }

    function open() { if (trigger) trigger.setAttribute('aria-expanded', 'true'); }
    function close() { if (trigger) trigger.setAttribute('aria-expanded', 'false'); }

    if (trigger) {
      trigger.addEventListener('click', function () {
        trigger.getAttribute('aria-expanded') === 'true' ? close() : open();
      });
    }
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
      else if (trigger && !e.target.closest('[data-sko-select]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    root.querySelectorAll('[data-sko-option]').forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn.getAttribute('data-sko-option')); });
    });

    // Gallery thumbnails
    root.querySelectorAll('[data-sko-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (mainImage) mainImage.src = btn.getAttribute('data-full');
        root.querySelectorAll('[data-sko-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    // Accordions, one open at a time
    var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-sko-acc-toggle]'));
    function panelFor(t) {
      var id = t.getAttribute('aria-controls');
      return (id && document.getElementById(id)) || t.nextElementSibling;
    }
    function closeAcc(t) {
      var p = panelFor(t); if (!p) return;
      p.style.height = p.scrollHeight + 'px';
      requestAnimationFrame(function () { p.style.height = '0px'; });
      t.setAttribute('aria-expanded', 'false');
    }
    function openAcc(t) {
      var p = panelFor(t); if (!p) return;
      p.style.height = p.scrollHeight + 'px';
      t.setAttribute('aria-expanded', 'true');
      p.addEventListener('transitionend', function h(e) {
        if (e.propertyName !== 'height') return;
        p.removeEventListener('transitionend', h);
        if (t.getAttribute('aria-expanded') === 'true') p.style.height = 'auto';
      });
    }
    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        var isOpen = t.getAttribute('aria-expanded') === 'true';
        toggles.forEach(function (o) { if (o !== t && o.getAttribute('aria-expanded') === 'true') closeAcc(o); });
        isOpen ? closeAcc(t) : openAcc(t);
      });
    });

    // Rating scrolls to a target if one is configured
    var ratingBtn = root.querySelector('[data-sko-rating]');
    if (ratingBtn) {
      ratingBtn.addEventListener('click', function () {
        var sel = ratingBtn.getAttribute('data-target');
        var target = null;
        if (sel) { try { target = document.querySelector(sel); } catch (e) { target = null; } }
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* ---- Add both products, then apply the offer code ---- */
    if (cta) {
      cta.addEventListener('click', function () {
        // Say what is wrong rather than returning silently — an unset product
        // picker used to make the button look simply unresponsive.
        function fail(msg) { if (errorEl) errorEl.textContent = msg; }

        if (!scents.length) { fail('No scents are configured for this offer yet.'); return; }
        if (!selected) { fail('Choose a full-size scent first.'); return; }
        if (selected.soldOut) { fail('That scent is sold out — pick another one.'); return; }

        var kitId = parseInt(kitVariant, 10);
        var scentId = parseInt(selected.variantId, 10);
        if (!kitId) { fail('The main product has not been set on this section.'); return; }
        if (!scentId) { fail('"' + (selected.name || 'That scent') + '" has no product selected.'); return; }
        if (cta.disabled) return;

        var items = [{ id: kitId, quantity: 1 }];
        var scentItem = { id: scentId, quantity: 1 };
        // The second product is a subscription; without the selling plan it
        // would be added as a one-off purchase at the wrong price.
        if (selected.sellingPlan) scentItem.selling_plan = parseInt(selected.sellingPlan, 10);
        items.push(scentItem);

        var original = ctaLabel ? ctaLabel.textContent : '';
        cta.disabled = true;
        if (ctaLabel) ctaLabel.textContent = cta.getAttribute('data-adding') || 'Adding…';
        if (errorEl) errorEl.textContent = '';

        // Empty the cart first when asked, so checkout contains only this
        // offer and nothing the shopper added earlier. A failed clear stops
        // here rather than adding the offer on top of whatever was in there.
        var start = clearCart
          ? fetch('/cart/clear.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
            }).then(function (res) {
              if (!res.ok) throw new Error('Could not clear your cart. Please try again.');
            })
          : Promise.resolve();

        start
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items })
            });
          })
          .then(function (res) {
            return res.json().then(function (body) {
              if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart');
              return body;
            });
          })
          .then(function () {
            // /discount/<code> applies the code to the session and then follows
            // the redirect, so the code is live in cart and at checkout.
            var dest = afterAdd === 'cart' ? '/cart' : afterAdd === 'checkout' ? '/checkout' : '';
            if (discount) {
              window.location.href = '/discount/' + encodeURIComponent(discount)
                + '?redirect=' + encodeURIComponent(dest || '/cart');
              return;
            }
            if (dest) { window.location.href = dest; return; }
            if (typeof window.openSidecart === 'function') window.openSidecart();
          })
          .catch(function (err) {
            if (errorEl) errorEl.textContent = err.message;
          })
          .finally(function () {
            cta.disabled = false;
            if (ctaLabel) ctaLabel.textContent = original;
          });
      });
    }

    wireVideos(root);
    wireTooltips(root);

    // Start on the first scent that is actually purchasable.
    var initial = scents.filter(function (s) { return !s.soldOut; })[0] || scents[0];
    if (initial) { selected = initial; render(); }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sko]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
